import approve from '../../../assets/images/approve.png'
import reject from '../../../assets/images/reject.png'
import pending from '../../../assets/images/pending.png'


export const statusCheck = (status) => {
    switch (status) {
        case 0:
            return pending // 0 represents processing, set as warning to get a yellow color.
        case 1:
            return approve
        case 2:
            return reject
        default:
            return ''
    }
}

export const getStatusMessage = (status) => {
    switch (status) {
        case 0:
            return 'Doc is Pending';
        case 1:
            return 'Doc is Approved';
        case 2:
            return 'Doc is Rejected';
        default:
            return '';
    }
};

